import { render, staticRenderFns } from "./trainingServices.vue?vue&type=template&id=2327e11a&scoped=true"
import script from "./trainingServices.vue?vue&type=script&lang=js"
export * from "./trainingServices.vue?vue&type=script&lang=js"
import style0 from "./trainingServices.vue?vue&type=style&index=0&id=2327e11a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2327e11a",
  null
  
)

export default component.exports